module.exports = __webpack_public_path__ + "media/reskin-images/icon--x-14146a4c.svg";